<template>
  <div class="result-upper-row">
    <div class="container">
      <div class="row align-items-start flex-column-reverse flex-sm-row">
        <div class="col-sm-12 col-lg-6 col-md-7">
          <div class="backbutton-container">
            <!-- <a href="/#goals" class="btn-textlinkLeftIcon"><span><i class="ph-arrow-left-bold"></i></span>back</a> -->
          </div>
          <div class="investment-container">
            <h2 class="hf_heading02">What you need to know about your investment</h2>
            <!-- CALCULATOR SECTION -->
            <div class="calc-outer-container calculator-box">
              <div class="goals-calc-container">
                <div class="goals-calculator-box">
                  <div class="calculator">

                    <!-- calculator section for retirement goal -->
								    <form class="goalRetirement" action="showRetResult" method="post" id="showRetResult">
								    	<input type="hidden" v-model="_token" name="_token">

								      <div class="form-group dynamic-input">
								        <label>I am</label>
								        <input type="number" id="currentAge" name="currentAge" v-model="currentAgePass" class="restDot numbersonly width-dynamic" :class="currentAgeMClass" placeholder="40"  @keyup="resetCalculation()" min="0" maxlength="2" @input="updatecrAgeVal()" required>
								        <span>years old and I want to retire</span>
								      </div>
											<div class="form-group dynamic-input">
								        <label>at the age of</label>
								        <input type="number" id="retAge" name="retAge" v-model="retAgePass" class="restDot numbersonly width-dynamic" :class="retAgeMClass" placeholder="60" @keyup="resetCalculation()" min="0" maxlength="2" @input="updateretAgeVal()">
								        <span>years.</span>
								      </div>
								      <div class="form-group dynamic-input">
								        <label for="name">On retirement, my monthly need would be<span class="inr-symbol hf_dark">&#8377;</span></label>
								        <input type="text" id="amount" name="amountReqd" v-model="amountReqdPass" class="restDot numbersonly " :class="amountReqdMClass" placeholder="75,000" min="0" maxlength="10" required>
								      </div>
                      <div class="notification-message">
  								      <p v-show="showError" class="errorMessage inflation-text hf_bodytext02">
                          <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                    			{{ showErrorText }}
                  			</p>
                      </div>

								      <div class="recalculate-button-container">
                        <a href="javascript:void(0)" type="button" class="btn-textlinkLeftIcon lg-textlinkleftIcon" ref="myBtn" @click.stop="showResult(0)"><span class="ph-arrow-clockwise-bold"></span>Recalculate</a>
                      </div>
								    </form>
                    <!-- end calculator section for retirement goal -->
                    
                  </div>
                </div>
              </div>
            </div>
            <!-- END CALCULATOR SECTION -->
            <!-- CALCULATIONS RESULT SECTION -->
            <div class="calc-result-container">
                <!-- retirement goal result -->
                <p class="hf_bodytext01 goalRetirement">Considering inflation of <span class="calculation-number">{{ inflation }}</span>%, your monthly need would become <span class="inr-symbol hf_dark">&#8377;</span><span class="calculation-number">{{ fvResultHtml }}</span> in <span class="calculation-number">{{ noOfYear }}</span> years. So, by <span class="calculation-number">{{ accmpYear }}</span>, you would need a retirement corpus of <span class="inr-symbol hf_dark">&#8377;</span><span class="calculation-number">{{ pvResultHtml }}</span>.</p>
                <!-- end retirement goal result -->
            </div>
            <!-- END CALCULATIONS RESULT SECTION -->
            <!-- INVESTMENT SECTION -->
            <div class="current-invest-box">
              <div class="sip-container nonWealthGoal">
                <div class="education-box">
                  <p class="hf_bodytext02">You need to invest</p>
                  <h4 class="amount-txt"><span class="rupee-symbol">&#8377;</span><span>{{ recomdSIPHtml }}</span></h4>
                  <p class="hf_bodytext02">Per month</p>
                  <p class="hf_bodytext02 minHeight no-margin">for <span>{{ noOfYear }}</span> years to achieve your goal.</p>
                </div>
              </div>
              <div class="seperater-box nonWealthGoal">
                <p class="hf_subheading">OR</p>
              </div>
              <div class="lumpsum-container nonWealthGoal">
                <div class="education-box">
                  <p class="hf_bodytext02">You need to invest</p>
                  <h4 class="amount-txt"><span class="rupee-symbol">&#8377;</span><span>{{ recomdLumpsumHtml }}</span></h4>
                  <p class="hf_bodytext02">One time</p>
                  <p class="hf_bodytext02 minHeight no-margin">to achieve your goal.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- GOAL IMAGES SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-5">
          <div class="goal-image-box">
              <img src="img/goal-retirement.webp" class="goalRetirement" alt="">
          </div>
        </div>
        <!-- END GOAL IMAGES SECTION -->
      </div>
    </div>
  </div>
  <div class="result-lower-container nonWealthGoal">
    <div class="container">
      <div class="row d-flex flex-sm-row-reverse">
        <!-- INSIGHT SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-5">
          <div class="insight-container">
            <p class="hf_subheading">Valuable insights for you</p>
              <!-- insights for retirement goal -->
              <ul class="insight-list goalRetirement">
                <li>Creating a retirement corpus allows you to live the life you desire without compromising your lifestyle and depending on anyone.</li>
                <li>When you retire, you want sufficient liquidity, money that lasts your lifetime, and no liability (loans), and you also want to ensure you leave money behind for your children. So, plan accordingly.</li>
              </ul>
              <!-- end insights for retirement goal -->
          </div>
        </div>
        <!-- END INSIGHT SECTION -->
        
        <!-- COST OF DELAY SECTION -->
        <div class="col-sm-12 col-lg-6 col-md-7">
          <div class="delay-calculator-container">
            <p class="hf_subheading">Cost of delay</p>
            <!-- calculator section -->
  					<div class="goals-calculator-box">
              <div class="calculator">
    						<form action="#" role="form">
    							<div class="form-group">
                    <div class="goals-rangeSlider">
              				<div class="range-slider">
                        <p class="tip"><span>{{ value }}</span>year delay</p>
              					<input id="range" type="range" min="0" :max="csdnoOfYear" step="1" v-model="value" @change="updateSlider">
              				</div>
              			</div>
    							</div>
    						</form>
                <div class="notification-message">
                  <p v-show="csdshowError" class="errorMessage inflation-text hf_bodytext02">
                    <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                    {{ showErrorText }}
                  </p>
                </div>
                <div class="inflation-box" v-show="showAmtDiff">
                  <p class="hf_bodytext02">If you delay by <span>{{ value }}</span> {{ (value > 1 ? 'years' : 'year') }}, you would need to increase your monthly amount by</p>
                  <h4 class="inflation-text hf_dark"><span class="rupee-symbol">&#8377;</span>{{ csdMonthlyDiffHtml }}</h4>
                  <br/>
                  <p class="hf_bodytext02">or else you would miss your target by</p>
                  <h4 class="inflation-text hf_dark"><span class="rupee-symbol">&#8377;</span>{{ csdtargetDiffHtml }}</h4>
                </div>
    					</div>
            </div>
  					<!-- end calculator section -->
          </div>
        </div>
        <!-- END COST OF DELAY SECTION -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {
    	_token : this.$token,
      currentAgeMClass: '',
      retAgeMClass: '',
      amountReqdMClass: '',
      mandatoryClassName: 'redunderline',
    	showErrorText: '',
    	showError: false,
      showAmtDiff: false,
      fvResult: '',
      pvResult: '',
    	fvResultHtml: '',
    	pvResultHtml: '',
    	accmpYear: '',
    	inflation: '',
    	noOfYear: '',
      recomdSIP: '',
      recomdSIPHtml: '',
      recomdLumpsum: '',
      recomdLumpsumHtml: '',
      currentAgePass: '',
      retAgePass: '',
      amountReqdPass: '',

      //parameters for cost of delay
      csdnoOfYear: '',
      csdrecomdSIP: '',
      csdrecomdLumpsum: '',
      csdMonthlyDiffHtml: '',
      csdtargetDiffHtml: '',
      csdshowError: false,

      value: 0,
      // backgroundSize: '20% 100%',
    };
  },
  props: {
  	currentAge: { type:String, default:''},
  	retAge: { type:String, default:''},
  	amountReqd: { type:String, default:''},
  },
  watch: {
    amountReqdPass(){
      var res =  this.formatAmount(this.amountReqdPass)
      this.amountReqdPass = res;
    },
  },
  mounted(){
  	// console.log("mounted event triggered");
    this.currentAgePass = this.currentAge;
    this.retAgePass = this.retAge;
    this.amountReqdPass = this.amountReqd;
  	// console.log(this);
  	// console.log("currentAge ="+this.currentAge);
  	// console.log("retAge ="+this.retAge);
  	// console.log("amountReqd ="+this.amountReqd);
  	// this.showResult(0);
  	let temp = this.$refs.myBtn;
  	setTimeout(function() {
      temp.click();
    }, 1000);

  },
  methods: {
    updatecrAgeVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.currentAgePass.toString().length > maxlength){
        let number = this.currentAgePass;
        this.currentAgePass = number.toString().substring(0, number.toString().length - 1);
      }
    },
    updateretAgeVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.retAgePass.toString().length > maxlength){
        let number = this.retAgePass;
        this.retAgePass = number.toString().substring(0, number.toString().length - 1);
      }
    },
    updateSlider(e) {
      let clickedElement = e.target;
      let min = clickedElement.min;
      let max = clickedElement.max;
      let val = clickedElement.value;
      // this.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
      // console.log(clickedElement);
      // console.log("Slider val = "+val);
      if(val > 0){
        this.showResult(1);
      }else{
        this.showErrorText = "";
        this.csdshowError = false;
        this.showError = false;
        this.showAmtDiff = false;
      }
    },
  	showResult(costOfDelay = 0){
  		// console.log("Click event triggered "+costOfDelay);

  		//Check for validation and collect data for calculations
  		//======================================================
  		let amountReqd = this.amountReqdPass;
      amountReqd = String(amountReqd).replace(new RegExp(',', 'g'), '');
  		let retAge = this.retAgePass;
  		let currentAge = this.currentAgePass;

      // When recalculate is press slider set to 0 again
      //================================================
      if(costOfDelay == 0){
        this.value = 0;
        this.showAmtDiff = false;
      }

  		if(amountReqd == "" || amountReqd == undefined || retAge == "" || retAge == undefined || currentAge == "" || currentAge == undefined){
  			this.showErrorText = "Please enter mandatory data first";
  			this.showError = true;
        this.csdshowError = false;

        // Check for mandatory fields
        //==============================
        if(amountReqd == "" || amountReqd == undefined){
          this.amountReqdMClass = this.mandatoryClassName;
        }else{
          this.amountReqdMClass = "";
        }

        if(retAge == "" || retAge == undefined){
          this.retAgeMClass = this.mandatoryClassName;
        }else{
          this.retAgeMClass = "";
        }

        if(currentAge == "" || currentAge == undefined){
          this.currentAgeMClass = this.mandatoryClassName;
        }else{
          this.currentAgeMClass = "";
        }
  		}else{	
        //remove all redunderline class for mandatory
        //============================================
        this.amountReqdMClass = "";
        this.retAgeMClass = "";
        this.currentAgeMClass = "";

  			//Check all the basic validations eg.age, amt
				//=============================================
				axios.post('/chkRetGoalValidations',{amountReqd: amountReqd, retAge: retAge, currentAge: currentAge, calcReq: 1, _token: this.$token})
        .then((response)=>{
        	// console.log(response);
        	let resData = response.data;
        	if(resData.status == true){
						this.showErrorText = "";
			    	this.showError = false;

        		let survivalAge = resData.survivalAge; 
        		let inflrateData = resData.inflrate; 
			    	let inflrate = inflrateData['inflrate'];
			  		let goalLoanTenure = inflrateData['goalLoanTenure'];
			  		let goalLoanRoi = inflrateData['goalLoanRoi'];
			  		let otherInflationPostRetInfl = inflrateData['otherInflationPostRetInfl'];
			  		let siprorarray = resData.sipRatesArray;
            var totalNumberOfMonths = (parseFloat(retAge *12) - parseFloat(currentAge * 12));
            var noOfYearToAccGoal = totalNumberOfMonths/12; // no of year to accomplish goal

            if(costOfDelay == 0){
              this.noOfYear = noOfYearToAccGoal;
              this.csdnoOfYear = noOfYearToAccGoal - 1;
            }

            //================================================
            // Calculate Future value FV
            //================================================            
            this.fvResult = Math.round(this.calculateFV(inflrate, noOfYearToAccGoal, '0', amountReqd));
            // console.log("fvResult = "+this.fvResult+" => "+inflrate+" => "+noOfYearToAccGoal+" => "+amountReqd);

            //================================================
            // Calculate Present value PV
            //================================================
            var postRetirementPeriod = parseInt(survivalAge) - parseInt(retAge); // this is used to calculate periods
            // console.log("otherInflationPostRetInfl="+otherInflationPostRetInfl);
            var rate = otherInflationPostRetInfl/12;
            var periods = postRetirementPeriod*12;

            var payment = -Math.round(this.fvResult);
            this.pvResult = Math.round(this.calculatePV(rate, periods, payment, '', 1));
            // console.log("pvResult = "+this.pvResult+" => "+rate+" => "+periods+" => "+payment);

            //================================================
            // Calculate Present value PMT
            //================================================

            // // -----------------------------------
            // // console.log(siprorarray);
            // let sipRorRate = 0;
            // siprorarray.forEach((value,index) => {
            //  // console.log(noOfYearToAccGoal+" => "+value.minAccmpYrs+" - "+value.maxAccmpYrs+" => "+value.rateOfReturn);
           //    if(noOfYearToAccGoal >= value.minAccmpYrs && noOfYearToAccGoal < value.maxAccmpYrs){
            //    this.sipRorRate = value.rateOfReturn;
            //  }
            // });
            // // -----------------------------------

            // // console.log("sipRorRate ="+this.sipRorRate);
            // var preRetirementReturnValue = this.sipRorRate/12; //pre retirement return value from inflation master for retirement
            // var periodsForSip = noOfYearToAccGoal*12;
            // var sipRequired = Math.round(this.calculatePMT(preRetirementReturnValue, periodsForSip, '', -this.pvResult, 1));
            // console.log("pmtResult = "+sipRequired+" => "+preRetirementReturnValue+" => "+periodsForSip+" => "+this.pvResult);
            // // =============================================================

            this.accmpYear = (parseInt(new Date().getFullYear()) + parseInt(noOfYearToAccGoal));
            this.inflation = Math.round(inflrate*100);
            // console.log("accmpYear = "+this.accmpYear);
            // console.log("inflation = "+this.inflation);

            // show fv and pv result
            // =============================================================
            this.fvResultHtml = this.shorthandCurrency(Math.round(this.fvResult), true);
            this.pvResultHtml = this.shorthandCurrency(Math.round(this.pvResult), true);
            // console.log("fvResultHtml = "+this.fvResultHtml);
            // console.log("pvResultHtml = "+this.pvResultHtml);
            //====================================

            //================================================
            // Calculate Monthly and Lumpsum
            //================================================
            // console.log("Calculate Monthly and Lumpsum");
            let goalAccYearApi = (costOfDelay == 0 ? this.accmpYear : (this.accmpYear - this.value));
            axios.post('/getRecomdInvstValuesWithoutGoal',{goalType: 'RET', netCorpus: this.pvResult, goalAccYear: goalAccYearApi, _token: this.$token})
            .then((result)=>{
              // console.log(result);
              let resData = result.data;
              if(resData.status == 1){
                let resResult = JSON.parse(resData.result);
                let resResData = resResult.goalRecomdInvstValuesList['0'];

                if(costOfDelay == 0){
                  this.recomdSIP = resResData.recomdSIP;
                  this.recomdLumpsum = resResData.recomdLumpsum;

                  // Amounts are in shorthand L or cr
                  //======================================================
                  // this.recomdSIPHtml = this.shorthandCurrency(resResData.recomdSIP,true);
                  // this.recomdLumpsumHtml = this.shorthandCurrency(resResData.recomdLumpsum, true);

                  this.recomdSIPHtml = this.commaSeparateNumber(resResData.recomdSIP,true);
                  this.recomdLumpsumHtml = this.commaSeparateNumber(resResData.recomdLumpsum, true);
                }else{
                  this.csdrecomdSIP = resResData.recomdSIP;
                  // this.csdrecomdLumpsum = resResData.recomdLumpsum;
                }

                //show amount differnce after cost of delay
                //==========================================
                if(costOfDelay == 1){
                  this.showAmtDiff = true;

                  //show monthly differnece to the user 
                  //=====================================
                  let monthlyDiff = this.csdrecomdSIP - this.recomdSIP;
                  this.csdMonthlyDiffHtml = this.shorthandCurrency(monthlyDiff, true);
                  // console.log("recomdSIP="+this.recomdSIP);
                  // console.log("csdrecomdSIP="+this.csdrecomdSIP);
                  // console.log("monthlyDiff="+monthlyDiff);
                }else{
                  this.showAmtDiff = false;
                }

              }else{
                this.showErrorText = resData.errcode+"  "+(resData.errmsg ? resData.errmsg : '');
                if(costOfDelay == 0){
                  this.showError = true;
                  this.csdshowError = false;
                }else{
                  this.csdshowError = true;
                  this.showError = false;
                }
              }
            }).catch(result => {
                console.log(result)
            })

            //================================================
            // Calculate Future value on cost of delay slider
            //================================================
            if(costOfDelay == 1){
              // console.log((this.noOfYear - this.value));
              axios.post('/csdCalcFV',{sipInvst: this.recomdSIP, noOfMonths: ((this.noOfYear - this.value)*12), _token: this.$token})
              .then((result)=>{
                // console.log(result);
                let fvData = result.data;
                if(fvData.status == 1){
                  let fvResultApi = JSON.parse(fvData.result);
                  let futureValue = fvResultApi.futureValue;

                  //show Corpus differnece to the user 
                  //=====================================
                  let targetDiff = this.pvResult - futureValue;
                  this.csdtargetDiffHtml = this.shorthandCurrency(targetDiff, true);
                  // console.log("pvResult="+this.pvResult);
                  // console.log("futureValue="+futureValue);
                  // console.log("corpDiff="+targetDiff);

                }else{
                  this.showErrorText = resData.errcode+"  "+(resData.errmsg ? resData.errmsg : '');
                  this.csdshowError = true;
                  this.showError = false;
                }
              }).catch(result => {
                  console.log(result)
              })
            }
        	}else{
            if(resData.error == undefined){
              this.showErrorText = "Page session expired, Please refresh the page";
              this.showError = true;
              this.csdshowError = false;
            }else{
              this.showErrorText = resData.error;
              this.showError = true;
              this.csdshowError = false;
            }
        	}
        }).catch(response => {
		        console.log(response.data);
		    })
  		}
  	},
  	resetCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showErrorText = "";
    	this.showError = false;
    }
  },
};
</script>

<style lang="scss" scoped></style>
